import { Grid } from '@mui/material';
import { useComplexCardStyles } from '../VehicleCard.style';
import TextRender from 'components/Global/TextRender/TextRender';
import { ICardInformationComplex } from 'interfaces/requestAQuote';
import SwiperCore, { A11y, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Icon, Icons } from 'components/Global/Icon/Icon';
import React from 'react';
import { Skeleton } from '@mui/material';
import { convertCostValue } from 'helpers/Prices';
import { appPalette } from 'theme/App.palette';

export interface IVehicleCardComplex {
  cardInfo: ICardInformationComplex;
  image?: string;
  imgLoaded: boolean;
  imgError: boolean;
}

const { light_grey_1 } = appPalette.colors;

const swipperNavigation = {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
};

const swipperPagination = {
  clickable: true,
  bulletActiveClass: 'active',
  el: `.swiper-pagination`,
  renderBullet: (index: any, className: any) =>
    `<span class="${className}" index="${index}"></span>`,
};
export function VehicleCardComplex({
  cardInfo,
  imgLoaded,
  imgError,
}: IVehicleCardComplex) {
  const complexCardClasses = useComplexCardStyles();
  SwiperCore.use([Navigation, Pagination, A11y]);

  return (
    <Grid className={complexCardClasses.root} container direction="row">
      {imgLoaded && !imgError && cardInfo?.images ? (
        <Grid container className={complexCardClasses.swiperContainer}>
          <Swiper
            slidesPerView={1}
            navigation={swipperNavigation}
            pagination={swipperPagination}
            resizeObserver={true}
            loop
            initialSlide={0}
            className={`swiper ${complexCardClasses.swiper}`}
          >
            {cardInfo.images.map((photo, index) => (
              <SwiperSlide key={index}>
                <img
                  alt={cardInfo.modelName}
                  className={complexCardClasses.swiper_img}
                  src={`${photo}&width=500`}
                />
              </SwiperSlide>
            ))}
            <span
              className={`swiper-button-prev ${complexCardClasses.swiper_navigation_button} ${complexCardClasses.swiper_navigation_button_prev}`}
            >
              <Icon type={Icons.arrowLeft} color={light_grey_1} />
            </span>
            <span
              className={`swiper-button-next ${complexCardClasses.swiper_navigation_button} ${complexCardClasses.swiper_navigation_button_next}`}
            >
              <Icon type={Icons.arrowRight} color={light_grey_1} />
            </span>
            <div className={`swiper-pagination`} />
          </Swiper>
        </Grid>
      ) : (
        <Skeleton
          variant="rectangular"
          className={complexCardClasses.cardSkeleton}
        ></Skeleton>
      )}
      <Grid
        container
        direction="row"
        className={complexCardClasses.cardInfoContainer}
      >
        <Grid
          item
          container
          justifyContent={'space-between'}
          xs={12}
          className={complexCardClasses.modelContainer}
        >
          <span className="acr-secondary-title-4">{`${cardInfo.modelYear} ${cardInfo.modelName}`}</span>
          {cardInfo.msrp && (
            <span
              className={`acr-secondary-title-4 ${complexCardClasses.msrp}`}
            >
              <TextRender
                tagName="p"
                text={`${cardInfo.msrp ? '$' : ''}${convertCostValue(
                  cardInfo?.msrp?.value || ''
                )}${cardInfo.msrp?.disclaimer}`}
              />

              <TextRender
                tagName="p"
                className="acr-paragraph-8"
                text={cardInfo.msrp?.caption || ''}
              />
            </span>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          container
          className={complexCardClasses.colorsContainer}
        >
          {cardInfo.colors &&
            cardInfo.colors?.map((color, index) => (
              <Grid
                key={index}
                item
                xs={6}
                className={complexCardClasses.colorItem}
              >
                <img
                  className={complexCardClasses.colorImg}
                  src={color?.image.sources.small}
                  alt={color.image.alternativeText}
                ></img>
                <span
                  className={`acr-paragraph-8 ${complexCardClasses.colorText}`}
                >
                  {color.name}
                </span>
              </Grid>
            ))}
        </Grid>
        <Grid item className={complexCardClasses.bullets} xs={12}>
          {cardInfo.bullets?.map((bullet, index) => (
            <span
              className={`bullet acr-paragraph-5 ${complexCardClasses.bullet}`}
              key={index}
            >
              <TextRender text={bullet} />
            </span>
          ))}
        </Grid>
        {(cardInfo.captionDescription || cardInfo.captionTitle) && (
          <Grid
            item
            container
            className={complexCardClasses.captionContainer}
            xs={12}
          >
            {cardInfo.captionTitle && (
              <span className="acr-caption-9">{cardInfo.captionTitle}</span>
            )}
            {cardInfo.captionDescription && (
              <TextRender
                className="acr-paragraph-8"
                text={cardInfo.captionDescription}
              />
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
